import { render, staticRenderFns } from "./ExpenditureView.vue?vue&type=template&id=2e31c19d&scoped=true&"
import script from "./ExpenditureView.vue?vue&type=script&lang=js&"
export * from "./ExpenditureView.vue?vue&type=script&lang=js&"
import style0 from "./ExpenditureView.vue?vue&type=style&index=0&id=2e31c19d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e31c19d",
  null
  
)

export default component.exports